/**
 * Form Inputs interactions.
 *
 */
import feature from '../../utils/feature';
import functions from '../../utils/functions';

export default (($, /* eslint-disable */ window, undefined /* eslint-enable */) => {

  // ----
  // upload input functionality ----
  const uploaderFieldClass = 'js-file-upload-wrapper';
  const uploaderFieldSelector = `.${uploaderFieldClass}`;
  const uploaderFieldEntryClass = 'js-file-upload-entry';
  const uploaderFieldEntrySelector = `.${uploaderFieldEntryClass}`;
  const uploaderFieldRemoveClass = 'js-file-upload-remove';
  const uploaderFieldRemoveSelector = `.${uploaderFieldRemoveClass}`;
  const uploaderFieldFileSelectedClass = '-file-selected';
  const uploaderFieldDisabledClass = 'file-upload-disabled';
  const uploaderFieldInputWrapperSelector = '.file-upload-hide';

  // list of file input being watched
  let uploadDisabledWatchList = $();

  // observer config
  const uploadObserverConfig = {
    attributes: true, 
    attributeFilter: ['disabled']
  };

  // observer
  const uploadObserver = new MutationObserver((mutationsList, observer) => {
    mutationsList.forEach(entry => {
      if (entry.type === 'attributes' && entry.attributeName === 'disabled') {
        $(entry.target).closest(uploaderFieldInputWrapperSelector).toggleClass(uploaderFieldDisabledClass, entry.target.disabled);
      }
    });
  });

  /**
   * Watch file input disabled attribute changes.
   * 
   * @param {HTMLElement} [context]
   */
  const watchUploadDisabled = async (context) => {
    context = context || window.document;
    $(':input[type="file"]', context)
      .not(uploadDisabledWatchList).each((idx, el) => {
        uploadDisabledWatchList = uploadDisabledWatchList.add(el);
        uploadObserver.observe(el, uploadObserverConfig);
      })
      .end()
      .each((idx, el) => {
        $(el).closest(uploaderFieldInputWrapperSelector).toggleClass(uploaderFieldDisabledClass, el.disabled);
      });
  };

  /**
   * File input global watch for styling.
   */
  const initUpload = async () => {
    $(uploaderFieldSelector).off('.aggrekoFiledInput');
    $(uploaderFieldSelector).parent().off('.aggrekoFiledInput');

    $(uploaderFieldSelector).on('focusin.aggrekoFiledInput focusout.aggrekoFiledInput', ':input[type="file"]', (ev) => {
      const t = $(ev.currentTarget);
      t.closest(uploaderFieldSelector).toggleClass('-focus', ev.type === 'focusin');
    });

    $(uploaderFieldSelector).on('input.aggrekoFiledInput', ':input[type="file"]', (ev) => {
      const t = $(ev.currentTarget);
      updateUploadValue(t);
    });

    $(uploaderFieldSelector).parent().on('click.aggrekoFiledInput', uploaderFieldRemoveSelector, (ev) => {
      const t = $(ev.currentTarget);
      removeUploadValue(t);
    });

    if (!feature.noHover) {
      $(uploaderFieldSelector).on('mouseenter.aggrekoFiledInput mouseleave.aggrekoFiledInput', (ev) => {
        const t = $(ev.currentTarget);
        t.toggleClass('-hover', ev.type === 'mouseenter');
      });
    }
  };

  /**
   * Update Custom file upload's uploaded file info.
   * 
   * @param {HTMLElement} el 
   * @returns 
   */
  const updateUploadValue = (el) => {
    const val = el.val();
    let elInfo = el.closest(uploaderFieldSelector).siblings(uploaderFieldEntrySelector);
    let fileName = val.split(/[/\\]/).pop();

    if (!val) {
      if (elInfo.length) {
        elInfo.remove();
      }
      el.closest(uploaderFieldSelector).removeClass(uploaderFieldFileSelectedClass);
      return;
    }

    if (!elInfo.length) {
      elInfo = $('<span>')
        .addClass(uploaderFieldEntryClass)
        .append(`<span role="button" class="${uploaderFieldRemoveClass}" aria-label="delete" tabindex="0">`, '<span>')
        .insertAfter(el.closest(uploaderFieldSelector));
    }

    elInfo.find('span').last().text(fileName);
    el.closest(uploaderFieldSelector).addClass(uploaderFieldFileSelectedClass);
  };

  /**
   * Clear Custom file upload's uploaded file info.
   * 
   * @param {HTMLElement} el 
   * @returns 
   */
  const removeUploadValue = (el) => {
    const entry = el.closest(uploaderFieldEntrySelector);
    const field = entry.siblings(uploaderFieldSelector);

    field.find(':input[type="file"]').each((idx, inp) => {
      inp.value = null;
      updateUploadValue($(inp));

      // fire focus then blur to trigger validation
      inp.focus();
      inp.blur();

      // return the focus
      inp.focus();
    });
  };
  // #upload input functionality
  // ----

  // ----
  // textarea input functionality
  const textareaWrapperSelector = '.js-textarea-wrapper';
  const textareaSelector = 'textarea[data-val-length-max]';
  const textareaLengthErrorClass = '-max-length-error';
  const textareaHasValidationClass = 'has-max-length-validation';
  const textareaRemainingLengthAttr = 'data-max-length-remaining';
  const textareaLengthValAttr = 'val-length-max';

  // input event handler (debounced)
  const _onTextareaInput = functions.debounce(ev => {
    updateTextarea(ev.currentTarget);
  }, 150);

  /**
   * Init textarea, watch for input changes
   */
  const initTextarea = async () => {
    $(textareaWrapperSelector).off('.aggrekoTextareaInput');
    $(textareaWrapperSelector).on('input.aggrekoTextareaInput', textareaSelector, _onTextareaInput);
  };

  /**
   * Update remaining characters
   * 
   * @param {HTMLElement} el 
   */
  const updateTextarea = (el) => {
    el = $(el);
    const l = el[0].value.length;
    const maxlength = Number(el.data(textareaLengthValAttr)) || 0;
    const r = maxlength - l;

    el.closest(textareaWrapperSelector).each((idx, elem) => {
      $(elem).attr(textareaRemainingLengthAttr, r);
      $(elem).toggleClass(textareaLengthErrorClass, r < 0);
    });
  };

  /**
   * Setup textarea remaining characters functionality.
   * 
   * @param {HTMLElement} [context]
   */
  const setupTextarea = async (context) => {
    context = context || window.document;
    $(textareaWrapperSelector, context).find(textareaSelector).each(function() {
      $(this).closest(textareaWrapperSelector).addClass(textareaHasValidationClass);
      
      updateTextarea(this);
    });
  };
  // #textarea input functionality 
  // ----
  
  // public interface
  const api = () => {
    initUpload();
    initTextarea();
    watchUploadDisabled();
    setupTextarea();
  };

  // public interface to be used on dynamic content (e.g. forms rendered by AJAX)
  api.initForm = (context) => {
    watchUploadDisabled(context);
    setupTextarea(context);
  };

  return api;
})(jQuery, window);